<template>
  <v-layout fill-height column class="page-solution-intro">
    <v-container flex-fill fluid>
      <div class="solution-intro-title">{{ title }}</div>
      <div class="solution-intro-subtitle">{{ smallTitle }}</div>
      <div class="solution-intro-desc" v-html="description"></div>
      <!-- <div class="text-center fs-14 gray--text">
          심호흡을 크게 3번 하면서<br>나의 몸과 마음을 느껴보세요.
      </div> -->
    </v-container>
    <FooterBtns :ok="'시작하기'" @submit="$emit('next')"/>
  </v-layout>
</template>
<script>
import FooterBtns from "@/components/btns/FooterBtns"

export default {
  props: ["title", "smallTitle", "description"],
  data: () => ({
    sheet: false,
  }),
  components: {
    FooterBtns,
  },
  computed: {},
  methods: {
    sheetStatus() {
      this.sheet = !this.sheet;
    },
  }
}
</script>
